<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
            <v-card-title class="headline">
                Выберите канал
            </v-card-title>
            <v-card-text>
                <v-list>
                    <v-list-item
                        v-for="channel in channels"
                        :key="channel.type"
                        @click="handleSelect(channel.type)"
                        class="channel-item"
                    >
                        <v-list-item-avatar>
                            <img :src="channel.logo" :alt="channel.name" class="channel-logo">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ channel.name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="showCancel"
                    text
                    @click="handleCancel"
                >
                    Отмена
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { CHANNEL_TYPES } from '@/vars/general'

export default {
    name: 'ChannelSelectionModal',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        showCancel: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        channels() {
            return [
                {
                    type: CHANNEL_TYPES.whatsappChannel,
                    name: 'WhatsApp',
                    logo: require('@/assets/img/messenger-logo/wa-logo.png'),
                },
                {
                    type: CHANNEL_TYPES.telegramChannel,
                    name: 'Telegram',
                    logo: require('@/assets/img/messenger-logo/telegram-logo.png'),
                },
                {
                    type: CHANNEL_TYPES.maxChannel,
                    name: 'MAX',
                    logo: require('@/assets/img/messenger-logo/max-logo.png'),
                },
                {
                    type: CHANNEL_TYPES.maxBusiness,
                    name: 'MAX Business',
                    logo: require('@/assets/img/messenger-logo/max-logo.png'),
                },
            ]
        },
    },
    methods: {
        handleSelect(channelType) {
            this.$emit('confirm', channelType)
        },
        handleCancel() {
            this.$emit('cancel')
        },
    },
}
</script>

<style lang="sass" scoped>
.channel-item
    cursor: pointer
    
    &:hover
        background-color: #f5f5f5

.channel-logo
    width: 28px
    height: 28px
    object-fit: contain
</style>

